export interface InventoryStockTransactionRow {
  id: string;
  company_id: string;
  company_name: string;
  store_id: string;
  store_code: string;
  store_name: string;
  item_id: string;
  item_code: string;
  item_name: string;
  txn_type: string;
  quantity_delta: number;
  unit_price: number;
  line_amount: number;
  posted_at: string;
  document_type: string;
  document_id?: string | null;
  reference_no: string;
  lot_no: string;
  bin_location: string;
  note: string;
  created_at?: string;
  updated_at?: string;
}

export interface InventoryStockTransactionFormData {
  company_id: string;
  company_name?: string;
  store_code: string;
  store_name: string;
  item_code: string;
  item_name: string;
  txn_type: string;
  quantity_delta: string;
  unit_price: string;
  line_amount: string;
  posted_at: string;
  document_type: string;
  document_id: string;
  reference_no: string;
  lot_no: string;
  bin_location: string;
  updated_at: string;
  note: string;
}

export const stockTransactionStateOptions = [
  { id: 'all', name: 'Tất cả' },
  { id: 'receipt', name: 'Nhập kho' },
  { id: 'issue', name: 'Xuất kho' },
  { id: 'return', name: 'Hoàn trả' },
  { id: 'adjustment', name: 'Điều chỉnh' },
];

const todayString = new Date().toISOString();

export const createDefaultStockTransactionForm = (companyId: string): InventoryStockTransactionFormData => ({
  company_id: companyId,
  company_name: '',
  store_code: '',
  store_name: '',
  item_code: '',
  item_name: '',
  txn_type: '',
  quantity_delta: '0',
  unit_price: '0',
  line_amount: '0',
  posted_at: '',
  document_type: '',
  document_id: '',
  reference_no: '',
  lot_no: '',
  bin_location: '',
  updated_at: todayString,
  note: '',
});